import { isDisabledByRule } from "components/Omnisearch/disableFilterWhen";
import { parseOmnisearch } from "components/Omnisearch/FilterPopover";
import { ReactNode, useState } from "react";
import { Navigate, useLocation, useMatch } from "react-router-dom";
import { removeKeyInOmnisearch } from "utils/omnisearchUtils";

import { REPORT_KIND_DISABLED_WHEN } from "./AssignmentManagerTable/chemicalFacilitiesFilters";

/** The search without its Report Kind when No Report rules it out; undefined if there's nothing to drop. */
function withoutRuledOutReportKind(omnisearch: string): string | undefined {
  const values = parseOmnisearch(omnisearch);
  if (values.reportKind === undefined || !isDisabledByRule(REPORT_KIND_DISABLED_WHEN, values)) {
    return undefined;
  }
  return removeKeyInOmnisearch(omnisearch, "reportKind");
}

/**
 * Holds the dashboard back until a Report Kind that No Report rules out is dropped from the search
 * it opened with (an old link, say), so nothing fetches with it. Only on open: rewriting the search
 * later would delete what the user is typing.
 */
export function DropRuledOutReportKindOnOpen({ children }: { children: ReactNode }) {
  const location = useLocation();
  const facilitiesMatch = useMatch("/staff/fulfillment/facilities");
  const [openedLocationKey] = useState(location.key);
  const [cleanedOmnisearch] = useState(() =>
    facilitiesMatch
      ? withoutRuledOutReportKind(new URLSearchParams(location.search).get("omnisearch") ?? "")
      : undefined
  );

  // Any navigation after the one that opened the page means the cleanup has landed.
  if (cleanedOmnisearch === undefined || location.key !== openedLocationKey) {
    return children;
  }

  const params = new URLSearchParams(location.search);
  params.set("omnisearch", cleanedOmnisearch);
  return <Navigate to={{ pathname: location.pathname, search: params.toString() }} replace />;
}
